export default function realMod(a: number, b: number) {
	return ((a % b) + b) % b
}
